import { Navigate, Outlet, useLocation } from "react-router-dom";
import { rolePermissions } from "../../utils/rolePermissions";

const ProtectedRoute = () => {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }

  const role = user?.Role?.name;
  const allowedRoutes = rolePermissions[role] || [];
  const currentPath = location.pathname;

  // SUPER_ADMIN → allow all
  if (allowedRoutes.includes("*")) {
    return <Outlet />;
  }

  // SPONSOR → only own profile
  if (role === "SPONSOR" && currentPath.startsWith("/view-profile")) {
    const userIdFromUrl = currentPath.split("/")[2];

    if (userIdFromUrl === user?.id) {
      return <Outlet />;
    } else {
      return <Navigate to="/sponsors" replace />;
    }
  }

  // Normal permission check
  const isAllowed = allowedRoutes.some((route) =>
    currentPath.startsWith(route)
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;